var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applicant"},[_c('transition',{attrs:{"name":"routerfade-animation"}},[_c('router-view',{staticClass:"applicant__router"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }